module.exports = __webpack_public_path__ + "static/img/reseveration.f04c1dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/reseveration.png
// module id = 1880
// module chunks = 0